

<template>

<div class="mainAppHomePage" data-font-size="10" data-font-size-type="px">
   <div class="overlay" data-font-size="10" data-font-size-type="px"></div>
   <div data-font-size="10" data-font-size-type="px">
      <div class="hp rteContainer" data-font-size="10" data-font-size-type="px">
         <div class="rteBox" data-font-size="10" data-font-size-type="px">
            <h1 class="mainTitle" data-font-size="35" data-font-size-type="px">אודות אתר הנדל"ן הממשלתי</h1>
            <div class="rteBoxInner" data-font-size="10" data-font-size-type="px">
               <section class="rte">
                  <div class="umb-grid" data-font-size="10" data-font-size-type="px">
                     <div class="grid-section" data-font-size="10" data-font-size-type="px">
                        <div>
                           <div class="row clearfix">
                              <div class="col-md-4 column">
                                 <div><img src="/images/trendsimg.png" alt=""></div>
                              </div>
                              <div class="col-md-8 column">
                                 <div>
                                    <div class="" data-font-size="16" data-font-size-type="px">
                                       <div class="viewContainer">
                                          <div class="aboutWrapper">
                                             <p>אתר הנדל"ן הממשלתי הינו תוצר של פעילות ממשלתית מתוקף החלטת הממשלה דר/10 מתאריך 3/6/2013 בנושא "שיפור מסד הנתונים הממשלתי אודות שוק הנדל"ן". המערכת מנגישה נתונים שעברו טיוב, תקנון וסינון, אודות נכסים ועסקאות מתוך מסדי הנתונים השונים של משרדי הממשלה העוסקים בתחום הנדל"ן. ניתן לחפש מידע על נכסים ועסקאות על גבי מפה, חיפוש חופשי, גוש/חלקה, שכונה וכתובת.</p>
                                             <p><strong>החזון: לאפשר לציבור גישה פשוטה באמצעות האינטרנט למידע אודות נתוני נכסים ועסקאות נדל"ן מתוך בסיסי המידע של משרדי הממשלה, בזמינות גבוהה, מתוך שיפור שרות הממשלה לציבור וחיסכון בהוצאות הממשלה</strong></p>
                                             <p>כוונתנו להעמיד לרשותכם כלי שרות להפקת מידע בתחום הנדל"ן אשר יסייע לקבלת החלטות בחיי היום יום. הצוות שלנו יאזין לכל שאלה, טענה, ביקורת, הצעה ורעיונות לשיפור.</p>
                                             <p>לתשומת לב!</p>
                                             <p>מטבע הדברים שאתר הנדל"ן הממשלתי המכיל מידע כה מגוון ממקורות שונים ברמות עידכון שונות, עשוי להכיל בתוכו סתירות פנימיות מסוימות. במקרים אלו, ראה פרק תנאי השימוש באתר.</p>
                                             <p>אתר הנדל"ן הממשלתי הוקם במרכז למיפוי ישראל בהנחיית הועדה הבין משרדית לשיפור מסד הנתונים אודות שוק הנדל"ן.</p>
                                             <p>לפרטים נוספים, ניתן לפנות אלינו –&nbsp;<a href="mailto:Nadlan@mapi.gov.il">Nadlan@mapi.gov.il</a></p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </section>
            </div>
         </div>
      </div>
      <div class="hpSearchSection rteSection" data-font-size="10" data-font-size-type="px"></div>
   </div>
</div>

</template>

   
<script>

export default {
    name: 'AboutView',
    data() {
        return {
            //
        }
    },
    methods: {
        //
    },
    mounted() {
        //
    }
}
</script>